export default{
    setTimeRangeDaily (state, data) {
        state.defaultParam.daily.date_start = data.start_date || null;
        state.defaultParam.daily.date_end = data.end_date || null;
    },
    setTimeRangeHourly (state, data) {
        state.defaultParam.hourly.datetime_start = data.start_datetime || null;
        state.defaultParam.hourly.datetime_end = data.end_datetime || null;
    },
}
